import React, {FC, ReactElement, useCallback, useEffect} from 'react'
import {observer} from 'mobx-react-lite'
import {useService} from '@yosmanyga/di'
import {Button, Container, Icon, Input, Text, useIcons,} from '@yosmanyga/rich-ui'
import {AuthenticationFrontendWithEmailCompleteController} from '../../controller'

const AuthenticationFrontendWithEmailComplete = observer(({
    templates,
    email,
    onCompleted,
    onBack
}: {
    templates: {
        layout: FC<{
            code_input: ReactElement,
            error: ReactElement | null,
            actions: ReactElement,
        }>
    },
    email: string,
    onCompleted: () => void,
    onBack: () => void,
}) => {
    const icons = useIcons()

    const controller = useService(AuthenticationFrontendWithEmailCompleteController, [])

    useEffect(() => {
        controller.load(email)
    }, [])

    const handleSubmit = useCallback(async () => {
        await controller.complete()

        if (controller.error) {
            return
        }

        onCompleted()
    }, [])

    if (controller.loading) {
        return <></>
    }

    return <templates.layout
        code_input={<Input
            value={controller.code || ''}
            keyboard='number'
            focus
            onChange={(value) => {
                controller.prepare(value)
            }}
            onEnter={handleSubmit}
            width='100%'
        />}
        error={controller.error
            ? <Text
                intent='negative'
            >
                {controller.error}
            </Text>
            : null
        }
        actions={<Container
            flow="row wrap"
            align={{
                main: 'center'
            }}
        >
            <Button
                intent='secondary'
                disabled={controller.completing}
                onClick={onBack}
            >
                <Icon
                    component={icons.actions.back}
                    size='xxs'
                />
                <Text>Back</Text>
            </Button>
            <Button
                intent='primary'
                progress={controller.completing}
                disabled={controller.completing}
                margin={{
                    left: 1
                }}
                onClick={handleSubmit}
            >
                <Icon
                    component={icons.actions.ok}
                    size='xxs'
                />
                <Text>Continue</Text>
            </Button>
        </Container>}
    />
})

export {
    AuthenticationFrontendWithEmailComplete
}
